import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin } from 'lucide-react';
import { companyInfo } from '../mock';

export const Footer = () => {
  const quickLinks = [
    { name: 'Home', path: '/' },
    { name: 'About Us', path: '/about' },
    { name: 'Products', path: '/products' },
    { name: 'Contact Us', path: '/contact' }
  ];

  return (
    <footer className="bg-slate-900 text-white">
      <div className="container mx-auto px-4 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-12">
          {/* Company Info */}
          <div>
            <Link to="/" className="flex items-center space-x-3 mb-6 group">
              <div className="relative w-12 h-12">
                {/* Benzene ring structure */}
                <div className="bg-gradient-to-br from-orange-500 to-orange-600 rounded-lg flex items-center justify-center transform group-hover:scale-105 transition-transform w-12 h-12">
                  <svg 
                    viewBox="0 0 24 24" 
                    className="w-8 h-8 text-white"
                    fill="none" 
                    stroke="currentColor" 
                    strokeWidth="2"
                    strokeLinecap="round" 
                    strokeLinejoin="round"
                  >
                    <polygon points="12,2 21,7 21,17 12,22 3,17 3,7" />
                    <circle cx="12" cy="12" r="4" />
                  </svg>
                </div>
              </div>
              <div className="flex flex-col">
                <span className="text-xl font-bold text-white">Shalibhadra</span>
                <span className="text-xs text-slate-300 -mt-1">Chemicals</span>
              </div>
            </Link>
            <p className="text-slate-400 text-sm mb-6">
              {companyInfo.tagline}
            </p>
            <p className="text-slate-400 text-sm">
              Trusted chemical supplier for pharmaceutical, paint, ink, and construction industries.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-6">Quick Links</h3>
            <ul className="space-y-3">
              {quickLinks.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-slate-400 hover:text-orange-400 transition-colors text-sm"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-semibold mb-6">Contact Us</h3>
            <div className="space-y-4">
              <div className="flex items-start space-x-3">
                <MapPin className="w-5 h-5 text-orange-400 flex-shrink-0 mt-0.5" />
                <p className="text-slate-400 text-sm">{companyInfo.address}</p>
              </div>
              <div className="flex items-center space-x-3">
                <Phone className="w-5 h-5 text-orange-400 flex-shrink-0" />
                <a
                  href={`tel:${companyInfo.phone.split('/')[0].trim()}`}
                  className="text-slate-400 hover:text-orange-400 transition-colors text-sm"
                >
                  {companyInfo.phone}
                </a>
              </div>
              <div className="flex items-center space-x-3">
                <Mail className="w-5 h-5 text-orange-400 flex-shrink-0" />
                <a
                  href={`mailto:${companyInfo.email}`}
                  className="text-slate-400 hover:text-orange-400 transition-colors text-sm"
                >
                  {companyInfo.email}
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-slate-800 mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-slate-400 text-sm">
              © {new Date().getFullYear()} Shalibhadra Chemicals. All rights reserved.
            </p>
            <div className="flex items-center space-x-6">
              <Link
                to="/contact"
                className="text-slate-400 hover:text-orange-400 transition-colors text-sm"
              >
                Privacy Policy
              </Link>
              <Link
                to="/contact"
                className="text-slate-400 hover:text-orange-400 transition-colors text-sm"
              >
                Terms & Conditions
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};